import Sidebar from '../../components/Sidebar';
import Transitions from '../../components/Transition';
import ClientUserForm from './components/ClientUserForm';

export default function EditClientUser() {
  return (
    <>
      <Sidebar active="ClientUsers" />
      <Transitions>
        <ClientUserForm edit />
      </Transitions>
    </>
  );
}
